import { useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import styles from "./BuyPop.module.scss";

// img
import bPay from "../../../assets/images/bitanicapay.png";

import p1 from "../../../assets/images/current.png";
import diamond from "../../../assets/images/diamond.png";
import { useDispatch, useSelector } from "react-redux";
import {
  buyEnergy,
  getCustomPurchaseLink,
  checkPaymentStatus,
  updateProfile,
  cancelPayment,
  getUserProfile,
  createPaymentOrder,
  payWithBitanica,
  customPayWithBitanica,
} from "../../../lib/store/actions";
import { showToast, isMobile } from "../../../helper/common";
import useEightHourCountdown from "../../../hooks/useEightHrTimer";
// import useUserBalance from "../../../hooks/useUserBalance";
import { useGameContext } from "../../../context/GameContext";
import styled from "styled-components";
import { useTonConnectUI, useTonAddress } from "@tonconnect/ui-react";
import VerifyingPaymentLoader from "../../Loader/verifyPayment";
import CustomLoader from "../../Loader/index";
import tokenIcn from "../../../assets/images/usdt-ton.png";
import cardIcn from "../../../assets/images/card.png";
import cardsIcn from "../../../assets/images/cards.png";
import cardNIcn from "../../../assets/images/cardn.png";
import {
  getUsdtWalletAddress,
  getNetworkName,
  usePreventTonModalClose,
} from "../../../helper/common";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
// import { useLanguage } from "../../../hooks/useLanguage";
const GAS_FEE = "50000000";

const BuyPop = ({
  bitanicaIframe,
  setBitanicaIframe,
  buy,
  setBuy,
  onFinish,
  onOrderCreate,
}) => {
  // const { t } = useTranslation();
  // const t = useLanguage();
  const { settings } = useSelector(({ Settings }) => Settings);
  const { butEnergyLoading } = useSelector(({ Game }) => Game);
  const minRequired = settings?.energy?.minimumCustomEnergyBuy || 1;
  const maxLimit = settings?.energy?.maxEnergyBalance || 1;

  usePreventTonModalClose();
  const { gameEnergyLeft, playSound } = useGameContext();
  const [qty, setQty] = useState(minRequired);
  const { hours, minutes, seconds } = useEightHourCountdown();
  const { btncBalance } = useGameContext();
  const [tonConnectUI] = useTonConnectUI();
  const [loading, setLoading] = useState(false);
  const [verify, setVerify] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [bpayPaymentMethod, setBpayPaymentMethod] = useState("");
  const userFriendlyAddress = useTonAddress();
  const dispatch = useDispatch();
  const [step, setStep] = useState(1);

  const { settingsData, userData } = useSelector(({ Settings, Auth }) => ({
    userData: Auth.user,
    settingsData: Settings.settings,
  }));

  const handleQty = (value) => {
    if (!settings?.energy?.maxEnergyBalance) return;
    if (value === "min") {
      if (qty > 1) {
        setQty((prev) => prev - 1);
      } else {
        setQty(1);
      }
    } else if (value === "add") {
      // if (
      //   (parseInt(qty) + 1) * settings?.energy?.chargeFor1Energy >=
      //   maxLimit
      // ) {
      //   return;
      // }
      // if (gameEnergyLeft + qty > settings?.energy?.maxEnergyBalance) return;
      // setQty((prev) => prev + 1);
      if (qty + 1 > maxLimit) return;

      setQty((prev) => prev + 1);
    }
  };

  const handleManualQty = (value) => {
    let newQty = Number(value);

    // allow only positive numbers
    if (isNaN(newQty)) {
      setQty(1);
      return;
    }

    // Minimum limit
    if (newQty < 1) {
      setQty(1);
      return;
    }

    if (newQty > maxLimit) {
      setQty(maxLimit);
      return;
    }

    setQty(newQty);
  };

  const purchaseEnergy = async (energyCount, currency, bpaymethod) => {
    if (currency === "btnc") {
      if (settings?.energy?.chargeFor1Energy * qty > btncBalance) {
        showToast("Insufficient balance!", "error");
        return;
      }
      let bodyParm = {
        quantity: energyCount,
      };
      dispatch(
        buyEnergy({
          data: bodyParm,
          callBack: (err, res) => {
            if (err) return;
            playSound("energybuy");
            setBuy(!buy);
            onFinish(res?.data);
          },
        }),
      );
    } else if (currency === "usdt") {
      if (
        settingsData?.energy?.maxEnergyBalance <
        userData.energyBalance + energyCount
      ) {
        showToast("Purchase not allowed—exceeds max energy limit.", "info");
        return;
      }
      if (tonConnectUI && !tonConnectUI?.connected) {
        console.error(
          !tonConnectUI?.connected,
          "ton modal open",
          tonConnectUI,
          tonConnectUI?.account,
        );
        let response = await tonConnectUI.openModal();
        if (tonConnectUI?.account) {
          console.error("Coming inside if ton connected account");
          const networkName = getNetworkName(tonConnectUI?.account?.chain);
          const targetNetwork = settingsData?.payment?.tonNetwork;
          if (networkName !== targetNetwork) {
            showToast(
              `Please switch your wallet network manually to ${targetNetwork} and reconnect!`,
              "error",
            );
            return;
          }
        }
        console.error(userFriendlyAddress, "asdfasdfasd");
        if (userFriendlyAddress) {
          console.error("Coming inside if ton user freindly address account");
          setLoading(true);
          dispatch(
            updateProfile({
              data: { _id: userData?._id, walletAddress: userFriendlyAddress },
              callBack: (err, data) => {
                if (err) {
                  setLoading(false);
                  showToast("Network Error! Please try later.", "error");
                  return;
                }
                dispatch(
                  getCustomPurchaseLink({
                    data: {
                      quantity: 1,
                      energy: energyCount,
                    },
                    callBack: async (err, res) => {
                      if (err) {
                        setLoading(false);
                        showToast("Network Error! Please try later.", "error");
                        return;
                      }
                      setLoading(!loading);
                      const { purchaseID, payload } = res.data;
                      if (tonConnectUI?.connected) {
                        const userTonAddress = tonConnectUI?.account?.address;
                        const userUSDTAddress = await getUsdtWalletAddress(
                          userTonAddress,
                          settingsData,
                        );
                        if (!userUSDTAddress) {
                          showToast("user usdt address not found ", "error");
                          setLoading(false);
                          return;
                        }
                        if (userUSDTAddress) {
                          try {
                            let result = await tonConnectUI.sendTransaction({
                              validUntil: Math.floor(Date.now() / 1000) + 300,
                              // network: settingsData?.payment?.tonNetwork,
                              messages: [
                                {
                                  address: userUSDTAddress || userTonAddress,
                                  amount: GAS_FEE,
                                  payload: payload,
                                },
                              ],
                            });
                            setLoading(false);
                            setVerify(true);
                            await verifyPayment(purchaseID);
                          } catch (error) {
                            setLoading(false);
                            setVerify(false);
                            showToast("Transaction was cancelled!", "error");
                          }
                        } else {
                          showToast("USDT Wallet not found!", "error");
                          setLoading(false);
                          setVerify(false);
                          handledHide();
                        }
                      }
                    },
                  }),
                );
              },
            }),
          );
        }
      } else if (tonConnectUI?.connected) {
        console.error("Coming inside if ton connected account else if");
        if (tonConnectUI?.account) {
          const networkName = getNetworkName(tonConnectUI?.account?.chain);
          const targetNetwork = settingsData?.payment?.tonNetwork;
          if (networkName !== targetNetwork) {
            showToast(
              `Please switch your wallet network manually to ${targetNetwork}`,
              "error",
            );
            return;
          }
        }
        if (!userData?.walletAddress && userFriendlyAddress) {
          console.error(
            "Coming inside if ton connected userFriendlyAddress else if",
          );

          setLoading(!loading);
          dispatch(
            updateProfile({
              data: { _id: userData?._id, walletAddress: userFriendlyAddress },
              callBack: (err, data) => {
                if (err) {
                  setLoading(false);
                  showToast("Network Error! Please try later.", "error");
                  return;
                }

                dispatch(
                  getCustomPurchaseLink({
                    data: {
                      quantity: 1,
                      energy: energyCount,
                    },
                    callBack: async (err, res) => {
                      if (err) {
                        setLoading(false);
                        return;
                      }
                      setLoading(!loading);
                      const { purchaseID, payload } = res.data;
                      if (tonConnectUI?.connected) {
                        const userTonAddress = tonConnectUI?.account?.address;
                        const userUSDTAddress = await getUsdtWalletAddress(
                          userTonAddress,
                          settingsData,
                        );
                        if (!userUSDTAddress) {
                          showToast("user usdt address not found ", "error");
                          setLoading(false);
                          return;
                        }
                        try {
                          let result = await tonConnectUI.sendTransaction({
                            validUntil: Math.floor(Date.now() / 1000) + 300,
                            // network: settingsData?.payment?.tonNetwork,
                            messages: [
                              {
                                address: userUSDTAddress || userTonAddress,
                                amount: GAS_FEE,
                                payload: payload,
                              },
                            ],
                          });
                          setLoading(false);
                          setVerify(true);
                          await verifyPayment(purchaseID);
                        } catch (error) {
                          console.error("erroror log", error);
                          setLoading(false);
                          setVerify(false);
                          showToast("Transaction was cancelled!", "error");
                          dispatch(
                            cancelPayment({
                              data: {
                                purchaseID: purchaseID,
                              },
                              callBack: async (err, res) => {
                                if (err) {
                                }
                              },
                            }),
                          );
                        }
                      } else {
                        if (tonConnectUI && !tonConnectUI?.connected) {
                          tonConnectUI.openModal();
                        }
                      }
                    },
                  }),
                );
              },
            }),
          );
        } else if (userData?.walletAddress) {
          setLoading(!loading);
          dispatch(
            getCustomPurchaseLink({
              data: {
                quantity: 1,
                energy: energyCount,
              },
              callBack: async (err, res) => {
                if (err) {
                  setLoading(false);
                  return;
                }
                setLoading(!loading);
                const { purchaseID, payload } = res.data;
                if (tonConnectUI?.connected) {
                  const userTonAddress = tonConnectUI?.account?.address;
                  const userUSDTAddress = await getUsdtWalletAddress(
                    userTonAddress,
                    settingsData,
                  );
                  if (!userUSDTAddress) {
                    showToast("user usdt address not found ", "error");
                    setLoading(false);
                    return;
                  }
                  try {
                    let result = await tonConnectUI.sendTransaction({
                      validUntil: Math.floor(Date.now() / 1000) + 300,
                      // network: settingsData?.payment?.tonNetwork,

                      messages: [
                        {
                          address: userUSDTAddress || userTonAddress,
                          amount: GAS_FEE,
                          payload: payload,
                        },
                      ],
                    });
                    setLoading(false);
                    setVerify(true);
                    await verifyPayment(purchaseID);
                  } catch (error) {
                    console.error("line-354", error);
                    setLoading(false);
                    setVerify(false);
                    showToast("Transaction was cancelled!", "error");
                    dispatch(
                      cancelPayment({
                        data: {
                          purchaseID: purchaseID,
                        },
                        callBack: async (err, res) => {
                          if (err) {
                          }
                        },
                      }),
                    );
                  }
                } else {
                  if (tonConnectUI && !tonConnectUI?.connected) {
                    tonConnectUI.openModal();
                  }
                }
              },
            }),
          );
        }
      } else {
        showToast("Please connect telegram wallet!", "error");
        setLoading(false);
      }
    } else if (currency === "gel") {
      setLoading(true);
      let bodyParm = {
        quantity: 1,
        energy: energyCount,
      };
      const mobile = isMobile();
      if (window.Telegram && window.Telegram.WebApp && mobile) {
        bodyParm.platform = "bot";
      } else {
        bodyParm.platform = "web";
      }
      dispatch(
        createPaymentOrder({
          data: bodyParm,
          callBack: (err, res) => {
            if (err) return;
            setBuy(!buy);
            onOrderCreate(res?.data);
            setLoading(false);
          },
        }),
      );
    } else if (currency === "Bitanica Pay") {
      setLoading(true);
      let bodyParm = {
        quantity: 1,
        energy: energyCount,
        payment_method: bpaymethod,
      };
      const mobile = isMobile();
      if (window.Telegram && window.Telegram.WebApp && mobile) {
        bodyParm.platform = "bot";
      } else {
        bodyParm.platform = "web";
      }
      dispatch(
        customPayWithBitanica({
          data: bodyParm,
          callBack: (err, res) => {
            if (err) {
              setLoading(false); // ✅ ensure loader stops on error
              return;
            }
            setBuy(!buy);
            onOrderCreate(res?.data);
            setLoading(false); // ✅ ensure loader stops on success
          },
        }),
      );
    }
  };

  const verifyPayment = async (purchaseID) => {
    try {
      const checkPayment = async (attempts = 0) => {
        if (attempts > 20) {
          dispatch(
            cancelPayment({
              data: {
                purchaseID: purchaseID,
              },
              callBack: async (err, res) => {
                if (err) {
                }
              },
            }),
          );
          throw new Error("Timeout waiting for payment");
        }
        if (!purchaseID) {
          throw new Error("No purchase ID provided");
        }
        try {
          const res = await dispatch(
            checkPaymentStatus({ data: { purchaseID } }),
          ).unwrap();
          if (res?.status === "success") {
            setVerify(false);
            showToast("Energy Purchased Successfully!", "success");
            handledHide();
            dispatch(
              getUserProfile({
                data: {
                  _id: userData?._id,
                },
                callBack: (err, res) => {
                  if (err) return;
                },
              }),
            );
            return;
          } else {
            await new Promise((resolve) => setTimeout(resolve, 5000));
            return await checkPayment(attempts + 1);
          }
        } catch (err) {
          console.error("Error checking payment:", err);
          setLoading(false);
          setVerify(false);
          handledHide();
          showToast("Package Payment timeout!", "error");
        }
      };
      await checkPayment();
    } catch (error) {
      console.error("Verification error:", error);
      setLoading(false);
      setVerify(false);
      handledHide();
      showToast("Package Payment timeout!", "error");
    } finally {
      setLoading(false);
    }
  };

  const handledHide = () => {
    setBuy(!buy);
  };

  const isBtncDisabled = settings?.energy?.chargeFor1Energy * qty > btncBalance;
  const isCardDisabled = qty < minRequired;

  return (
    <>
      {verify && <VerifyingPaymentLoader />}
      {loading && <CustomLoader />}
      <Modal
        show={buy}
        onHide={handledHide}
        backdrop="true"
        centered
        scrollable="true"
        className={`${styles.buyPop} bottomPop`}
        keyboard={false}
      >
        <div className="modalWrpper">
          <Modal.Body>
            <Button
              onClick={handledHide}
              variant="transparent"
              className="border-0 p-0 position-absolute"
              style={{ top: 15, right: 15 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M13.0024 26.0048C20.1834 26.0048 26.0048 20.1834 26.0048 13.0024C26.0048 5.82137 20.1834 0 13.0024 0C5.82137 0 0 5.82137 0 13.0024C0 20.1834 5.82137 26.0048 13.0024 26.0048ZM13.0062 14.1485L18.1747 19.3251L19.3205 18.1711L14.152 13.0026L19.3205 7.83412L18.1747 6.68827L13.0062 11.8568L7.83767 6.68015L6.6837 7.83412L11.8603 13.0026L6.6837 18.1711L7.83767 19.3251L13.0062 14.1485Z"
                  fill="#506380"
                />
              </svg>
            </Button>
            <div className="top pb-3 text-center">
              <h5
                className="m-0 text-white d-inline-block pb-1 fw-bold"
                style={{ borderBottom: "0.2px solid #07ECF9" }}
              >
                {step == 1 ? <>PURCHASE ENERGY</> : <>PAYMENT METHODS</>}
              </h5>
            </div>
            <div className="py-2">
              <div
                className="flex flex-column gap-10 mx-auto"
                // style={{ maxWidth: 290 }}
              >
                {step == 1 ? (
                  <>
                    <div
                      className={`${styles.box} shadow-sm position-relative mx-auto text-center rounded-4 p-3`}
                    >
                      <div className="py-1">
                        <img src={p1} alt="" className="img-fluid" />
                      </div>
                      <div
                        className={`${styles.quantity} pt-2 d-flex align-items-center justify-content-center gap-10`}
                      >
                        <Button
                          onClick={() => handleQty("min")}
                          className={`${
                            qty > 1 && styles.active
                          } d-flex align-items-center justify-content-center commonBtn border-0`}
                          style={{ minWidth: "unset" }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="15"
                            height="3"
                            viewBox="0 0 15 3"
                            fill="none"
                          >
                            <rect width="15" height="3" rx="1.5" fill="white" />
                          </svg>
                        </Button>
                        <input
                          type="number"
                          value={qty}
                          onChange={(e) => handleManualQty(e.target.value)}
                          className={`${styles.formControl} form-control text-center fw-bold text-white`}
                          min={1}
                        />
                        <Button
                          // disabled={
                          //   gameEnergyLeft + qty >=
                          //     settings?.energy?.maxEnergyBalance ||
                          //   (parseInt(qty) + 1) *
                          //     settings?.energy?.chargeFor1Energy >=
                          //     btncBalance
                          // }
                          disabled={qty >= maxLimit}
                          onClick={() => handleQty("add")}
                          className={`${
                            qty >= maxLimit ? "" : styles.active
                          } d-flex align-items-center justify-content-center commonBtn border-0`}
                          style={{ minWidth: "unset" }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="17"
                            height="16"
                            viewBox="0 0 17 16"
                            fill="none"
                          >
                            <rect
                              y="6.31738"
                              width="16.1092"
                              height="3.15924"
                              rx="1.57962"
                              fill="white"
                            />
                            <rect
                              width="15.7938"
                              height="3.22185"
                              rx="1.61092"
                              transform="matrix(0.00512754 -0.999987 0.999988 0.0049302 6.44098 15.7939)"
                              fill="white"
                            />
                          </svg>
                        </Button>
                      </div>
                      {qty >= maxLimit && (
                        <p className="m-0 text-danger">
                          Maximum {maxLimit} energy can be purchased
                        </p>
                      )}
                    </div>
                    <div className="">
                      <p className="m-0 pt-2 text-white text-start fw-light">
                        Choose Payment Method
                      </p>
                      <RadioSelect className="mt-2">
                        <div className="py-1">
                          <label
                            className="w-100 position-relative"
                            style={{
                              opacity: isCardDisabled ? 0.5 : 1,
                              pointerEvents: isCardDisabled ? "none" : "auto",
                              cursor: isCardDisabled
                                ? "not-allowed"
                                : "pointer",
                            }}
                          >
                            <div
                              onClick={() => {
                                if (!isCardDisabled) {
                                  setStep(2);
                                  setSelectedCurrency("");
                                }
                              }}
                              className="d-flex align-items-center text-white cursor-pointer justify-content-between gap-10 p-2"
                            >
                              <div className="left d-flex align-items-center gap-10">
                                <span className="icn flex-shrink-0 d-flex align-items-center justify-content-center p-2">
                                  <img
                                    src={cardsIcn}
                                    alt="card"
                                    className="img-fluid"
                                    style={{ height: 25 }}
                                  />
                                </span>
                                <div style={{ fontSize: "15px" }}>
                                  Visa/Mastercard
                                  <span
                                    className="d-block"
                                    style={{ color: "#8e8e8e", fontSize: 9 }}
                                  >
                                    Minimum{" "}
                                    {settings?.energy?.minimumCustomEnergyBuy}{" "}
                                    energy required
                                  </span>
                                </div>
                              </div>

                              <p className="m-0">
                                ${" "}
                                {(
                                  settings?.energy?.priceFor1Energy * qty
                                )?.toFixed(2)}
                              </p>
                            </div>
                          </label>
                        </div>
                        <div className="py-1">
                          <label
                            className="w-100 position-relative"
                            style={{
                              opacity: isBtncDisabled ? 0.5 : 1,
                              pointerEvents: isBtncDisabled ? "none" : "auto",
                              cursor: isBtncDisabled
                                ? "not-allowed"
                                : "pointer",
                            }}
                          >
                            <input
                              type="radio"
                              name="currency"
                              className="position-absolute h-100 w-100"
                              value="btnc"
                              checked={selectedCurrency === "btnc"}
                              onClick={() => setSelectedCurrency("btnc")}
                              disabled={isBtncDisabled}
                              style={{
                                cursor: isBtncDisabled
                                  ? "not-allowed"
                                  : "pointer",
                                left: 0,
                                top: 0,
                                zIndex: 999,
                                opacity: 0,
                              }}
                            />

                            <div className="d-flex align-items-center text-white justify-content-between gap-10 p-2">
                              <div className="left d-flex align-items-center gap-10">
                                <span className="icn flex-shrink-0 d-flex align-items-center justify-content-center p-2">
                                  <img
                                    src={diamond}
                                    alt="Diamond"
                                    className="img-fluid"
                                    style={{ height: 25 }}
                                  />
                                </span>
                                Bitanica Coin
                              </div>

                              <p className="m-0">
                                {settings?.energy?.chargeFor1Energy * qty}
                              </p>
                            </div>
                          </label>
                        </div>
                        <div className="py-1">
                          <label
                            className="w-100 position-relative"
                            style={{
                              opacity: isCardDisabled ? 0.5 : 1,
                              pointerEvents: isCardDisabled ? "none" : "auto",
                              cursor: isCardDisabled
                                ? "not-allowed"
                                : "pointer",
                            }}
                          >
                            <div
                              onClick={() => {
                                if (!isCardDisabled) {
                                  setStep(3);
                                  setSelectedCurrency("");
                                }
                              }}
                              className="d-flex align-items-center text-white cursor-pointer justify-content-between gap-10 p-2"
                            >
                              <div className="left d-flex align-items-center gap-10">
                                <span className="icn flex-shrink-0 d-flex align-items-center justify-content-center p-2">
                                  <img
                                    src={tokenIcn}
                                    alt="card"
                                    className="img-fluid"
                                    style={{ height: 25 }}
                                  />
                                </span>
                                <div style={{ fontSize: "15px" }}>
                                  Crypto
                                  <span
                                    className="d-block"
                                    style={{ color: "#8e8e8e", fontSize: 9 }}
                                  >
                                    Minimum{" "}
                                    {settings?.energy?.minimumCustomEnergyBuy}{" "}
                                    energy required
                                  </span>
                                </div>
                              </div>

                              <p className="m-0">
                                ${" "}
                                {(
                                  settings?.energy?.priceFor1Energy * qty
                                )?.toFixed(2)}
                              </p>
                            </div>
                          </label>
                        </div>
                      </RadioSelect>
                    </div>
                  </>
                ) : step == 3 ? (
                  <>
                    <RadioSelect className="mt-2">
                      <div className="py-1">
                        <label
                          className=" w-100 position-relative "
                          // style={{ opacity: "40%" }}
                        >
                          <input
                            type="radio"
                            className="position-absolute h-100 w-100 "
                            name="currency"
                            value="gel"
                            checked={selectedCurrency === "Bitanica Pay"}
                            onClick={() => {
                              setSelectedCurrency("Bitanica Pay");
                              setBpayPaymentMethod("crypto");
                            }}
                            style={{
                              cursor: "pointer",
                              left: 0,
                              top: 0,
                              zIndex: 999,
                              opacity: 0,
                            }}
                          />
                          <div className="text-white cursor-pointer p-3">
                            <div className="d-flex align-items-center text-white cursor-pointer justify-content-between gap-10 py-2">
                              <div className="left d-flex align-items-center gap-10">
                                <span className="icn flex-shrink-0 d-flex align-items-center justify-content-center p-2">
                                  <img
                                    src={bPay}
                                    alt="card"
                                    className="img-fluid"
                                    style={{ height: 25 }}
                                  />
                                </span>{" "}
                                Bitanica Pay
                              </div>
                              <p className="m-0">
                                ${" "}
                                {(
                                  settings?.energy?.priceFor1Energy * qty
                                )?.toFixed(2)}
                              </p>
                            </div>
                            <div
                              className="d-flex flex-wrap gap-2 pt-2"
                              style={{
                                borderTop: "1px solid rgba(255,255,255,0.08)",
                                fontSize: 12,
                              }}
                            >
                              <span className="text-white fw-sbold">
                                Supported in
                              </span>
                              <div className="d-flex align-items-center gap-3 flex-wrap">
                                <div className="d-flex align-items-center gap-1">
                                  {flagAZ}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    AZ
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagUA}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    UA
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagKZ}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    KZ
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagTR}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    TR
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagEE}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    EE
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagIT}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    IT
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagPL}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    PL
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagES}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    ES
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagFR}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    FR
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagGE}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    GE
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </label>
                        {/* <p className="m-0 text-center text-danger">
                          Under maintenance
                        </p> */}
                      </div>
                    </RadioSelect>

                    {/* spacer so “Supported in” has room */}
                    <LineSeperator className="position-relative text-center d-flex justify-content-center align-items-center mt-2">
                      <p className="m-0 px-2 position-relative text-white">
                        Or Buy with
                      </p>
                    </LineSeperator>
                    <RadioSelect className="mt-2">
                      <div className="py-1">
                        <label className=" w-100 position-relative ">
                          <input
                            type="radio"
                            className="position-absolute h-100 w-100 "
                            name="currency"
                            value="usdt"
                            checked={selectedCurrency === "usdt"}
                            onClick={() => setSelectedCurrency("usdt")}
                            style={{
                              cursor: "pointer",
                              left: 0,
                              top: 0,
                              zIndex: 999,
                              opacity: 0,
                            }}
                          />
                          <div className="d-flex align-items-center text-white cursor-pointer justify-content-between gap-10 p-2">
                            {/* <span>Buy with</span> */}
                            <div className="left d-flex align-items-center gap-10">
                              <span className="icn flex-shrink-0 d-flex align-items-center justify-content-center p-2">
                                <img
                                  src={tokenIcn}
                                  alt="USDT"
                                  className="img-fluid"
                                  style={{ height: 25 }}
                                />
                              </span>
                              Crypto
                            </div>
                            <p className="m-0">
                              {" "}
                              {(
                                settings?.energy?.priceFor1Energy * qty
                              )?.toFixed(2)}
                            </p>
                          </div>
                        </label>
                      </div>
                    </RadioSelect>
                  </>
                ) : (
                  <>
                    {" "}
                    <RadioSelect className="mt-2">
                      <div className="py-1">
                        <label
                          className=" w-100 position-relative "
                          // style={{ opacity: "40%" }}
                        >
                          <input
                            type="radio"
                            className="position-absolute h-100 w-100 "
                            name="currency"
                            value="gel"
                            checked={selectedCurrency === "Bitanica Pay"}
                            onClick={() => {
                              setSelectedCurrency("Bitanica Pay");
                              setBpayPaymentMethod("card");
                            }}
                            style={{
                              cursor: "pointer",
                              left: 0,
                              top: 0,
                              zIndex: 999,
                              opacity: 0,
                            }}
                          />
                          <div className="text-white cursor-pointer p-3">
                            <div className="d-flex align-items-center text-white cursor-pointer justify-content-between gap-10 py-2">
                              <div className="left d-flex align-items-center gap-10">
                                <span className="icn flex-shrink-0 d-flex align-items-center justify-content-center p-2">
                                  <img
                                    src={bPay}
                                    alt="card"
                                    className="img-fluid"
                                    style={{ height: 25 }}
                                  />
                                </span>{" "}
                                Bitanica Pay
                              </div>
                              <p className="m-0">
                                ${" "}
                                {(
                                  settings?.energy?.priceFor1Energy * qty
                                )?.toFixed(2)}
                              </p>
                            </div>
                            <div
                              className="d-flex flex-wrap gap-2 pt-2"
                              style={{
                                borderTop: "1px solid rgba(255,255,255,0.08)",
                                fontSize: 12,
                              }}
                            >
                              <span className="text-white fw-sbold">
                                Supported in
                              </span>
                              <div className="d-flex align-items-center gap-3 flex-wrap">
                                <div className="d-flex align-items-center gap-1">
                                  {flagAZ}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    AZ
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagUA}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    UA
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagKZ}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    KZ
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagTR}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    TR
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagEE}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    EE
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagIT}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    IT
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagPL}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    PL
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagES}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    ES
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagFR}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    FR
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagGE}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    GE
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </label>
                        {/* <p className="m-0 text-center text-danger">
                          Under maintenance
                        </p> */}
                      </div>
                    </RadioSelect>
                    {/* spacer so “Supported in” has room */}
                    {/* <LineSeperator className="position-relative text-center d-flex justify-content-center align-items-center mt-2">
                      <p className="m-0 px-2 position-relative text-white">
                        Or Buy with
                      </p>
                    </LineSeperator>
                    <RadioSelect className="mt-2">
                      <div className="py-1">
                        <label className="w-100 position-relative">
                          <input
                            type="radio"
                            className="position-absolute h-100 w-100"
                            name="currency"
                            value="gel"
                            checked={selectedCurrency === "gel"}
                            onClick={() => setSelectedCurrency("gel")}
                            style={{
                              cursor: "pointer",
                              left: 0,
                              top: 0,
                              zIndex: 999,
                              opacity: 0,
                            }}
                          />

                          <div className="text-white cursor-pointer p-3">
                            <div className="d-flex align-items-center justify-content-between gap-10 py-2">
                              <div className="left d-flex align-items-center gap-10">
                                <span className="icn flex-shrink-0 d-flex align-items-center justify-content-center p-2">
                                  <img
                                    src={cardNIcn}
                                    alt="card"
                                    className="img-fluid"
                                    style={{ height: 25 }}
                                  />
                                </span>
                                Credit/Debit Card
                              </div>
                              <p className="m-0">
                                ${" "}
                                {(
                                  settings?.energy?.priceFor1Energy * qty
                                )?.toFixed(2)}
                              </p>
                            </div>

                            <div
                              className="d-flex flex-wrap  gap-2 pt-2"
                              style={{
                                borderTop: "1px solid rgba(255,255,255,0.08)",
                                fontSize: 12,
                              }}
                            >
                              <span className="text-white fw-sbold">
                                Supported in
                              </span>
                              <div className="d-flex align-items-center gap-3 flex-wrap">
                                <div className="d-flex align-items-center gap-1">
                                  {flagAZ}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    AZ
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagTJ}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    TJ
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagKG}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    KG
                                  </span>
                                </div>
                                <div className="d-flex align-items-center gap-1">
                                  {flagUZ}
                                  <span
                                    style={{ fontSize: 13, fontWeight: 600 }}
                                  >
                                    UZ
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </label>
                      </div>
                    </RadioSelect> */}
                    {/* <Note className="d-flex align-items-center gap-10 p-3 mt-3">
                      <span className="flex-shrink-0">{noteIcn}</span>
                      <p className="m-0">
                        Credit/Debit Card payments are only supported in AZN
                        (Azerbaijan), TJS (Tajikistan), KGS (Kyrgyzstan), and
                        UZS (Uzbekistan).
                      </p>
                    </Note> */}
                  </>
                )}
              </div>
            </div>

            {/* <p
              className="text-center mx-auto"
              style={{ color: "#EBF049", maxWidth: 290 }}
            >
              {t("buy_pop.payment_note")}
            </p> */}

            <div
              // style={{ maxWidth: 290 }}
              className="mt-3 mx-auto text-center"
            >
              <Button
                style={{
                  height: 48,
                  width: "100%",
                }}
                disabled={butEnergyLoading || !selectedCurrency}
                onClick={() =>
                  purchaseEnergy(qty, selectedCurrency, bpayPaymentMethod)
                }
                className={`${styles.submitBtn} ${
                  (butEnergyLoading || !selectedCurrency) && styles.disabled
                } d-inline-flex align-items-center justify-content-center fw-bold commonBtn border-0`}
              >
                {butEnergyLoading ? <Spinner size="sm" /> : "Buy"}
              </Button>
            </div>
            <div className="py-2 mt-2">
              <p
                className="m-0 text-center"
                style={{
                  color: "#838282",
                  fontWeight: 500,
                  fontSize: 15,
                }}
              >
                <span className="mx-1">Auto Refill </span>
                <span className="themeClr d-inline-block" style={{ width: 80 }}>
                  {hours}:{minutes}:{seconds}
                </span>
              </p>
            </div>
          </Modal.Body>
        </div>
      </Modal>
    </>
  );
};

const LineSeperator = styled.div`
  z-index: 99;
  &:after {
    position: absolute;
    content: "";
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 1px;
    width: 100%;
    background: #1d1d20;
  }
  p {
    background: #0e0e11;
    z-index: 99;
    font-weight: 500;
  }
`;

const Note = styled.div`
  background: #3e2b10;
  border-radius: 20px;
  color: #ff9f0a;
`;

const RadioSelect = styled.div`
  ${
    "" /* > div {
    width: 33.333%;
  } */
  }
  label {
    > div {
      background: #151516;
      border-radius: 10px;
      min-height: 60px;

      font-size: 14px;
      font-family: "Space Grotesk", sans-serif;
      font-weight: 300;
      border: 1px solid transparent;
      .left {
        font-weight: 500;
      }
      .icn {
        height: 43px;
        width: 46px;
        background: #2d2d2d;
        border-radius: 10px;
      }
    }
  }
  input:checked + div {
    opacity: 1;
    border-color: #242afc;
  }
`;

export default BuyPop;

const noteIcn = (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10.75" cy="10.75" r="10" stroke="#FF9F0A" strokeWidth="1.5" />
    <path
      d="M10.742 13.75H10.751"
      stroke="#FF9F0A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.75 10.75L10.75 6.75"
      stroke="#FF9F0A"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const flagAZ = (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_az)">
      <mask
        id="mask0_az"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="18"
      >
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_az)">
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="#E3002E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 11.4287H24V17.143H0V11.4287Z"
          fill="#00AF62"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H24V5.71429H0V0Z"
          fill="#0097C5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.7144 8H14.8572V9.14286H13.7144V8Z"
          fill="#FBDCE2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.2859 10.2853C13.7648 10.979 12.9351 11.4282 12.0002 11.4282C10.4231 11.4282 9.14307 10.1482 9.14307 8.57101C9.14307 6.99387 10.4231 5.71387 12.0002 5.71387C12.9351 5.71387 13.7648 6.16301 14.2859 6.85672H12.5716C11.6254 6.85672 10.8574 7.62472 10.8574 8.57101C10.8574 9.5173 11.6254 10.2853 12.5716 10.2853H14.2859Z"
          fill="white"
        />
        <path
          d="M21.7141 0.571289H2.28557C1.3388 0.571289 0.571289 1.3388 0.571289 2.28557V14.857C0.571289 15.8038 1.3388 16.5713 2.28557 16.5713H21.7141C22.6609 16.5713 23.4284 15.8038 23.4284 14.857V2.28557C23.4284 1.3388 22.6609 0.571289 21.7141 0.571289Z"
          stroke="black"
          strokeOpacity="0.1"
          strokeWidth="1.14286"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_az">
        <rect width="24" height="17.1429" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const flagTJ = (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_flag)">
      <mask
        id="mask0_flag"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="18"
      >
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_flag)">
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 11.4287H24V17.143H0V11.4287Z"
          fill="#007100"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.6804 8.22885C13.7033 8.33971 13.7147 8.45399 13.7147 8.57171C13.7147 9.51799 12.9467 10.286 12.0004 10.286C11.0541 10.286 10.2861 9.51799 10.2861 8.57171C10.2861 8.45399 10.2976 8.33971 10.3204 8.22885C10.4804 8.74999 11.1707 9.14314 12.0004 9.14314C12.8301 9.14314 13.5204 8.74999 13.6804 8.22885ZM12.0004 8.00028C12.3158 8.00028 12.5718 7.74428 12.5718 7.42885C12.5718 7.11342 12.3158 6.85742 12.0004 6.85742C11.685 6.85742 11.429 7.11342 11.429 7.42885C11.429 7.74428 11.685 8.00028 12.0004 8.00028Z"
          fill="#F9CA00"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H24V5.71429H0V0Z"
          fill="#D20200"
        />
        <path
          d="M21.7141 0.571289H2.28557C1.3388 0.571289 0.571289 1.3388 0.571289 2.28557V14.857C0.571289 15.8038 1.3388 16.5713 2.28557 16.5713H21.7141C22.6609 16.5713 23.4284 15.8038 23.4284 14.857V2.28557C23.4284 1.3388 22.6609 0.571289 21.7141 0.571289Z"
          stroke="black"
          strokeOpacity="0.1"
          strokeWidth="1.14286"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_flag">
        <rect width="24" height="17.1429" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const flagKG = (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_kg)">
      <mask
        id="mask0_kg"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="18"
      >
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_kg)">
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="#EB0624"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.6642 10.8396C11.7751 10.851 11.8871 10.8567 12.0002 10.8567C12.1145 10.8567 12.2254 10.851 12.3362 10.8396L12.0002 9.99958L11.6642 10.8396ZM10.1145 10.2167C9.51678 9.74358 9.14307 9.0533 9.14307 8.2853C9.14307 7.37901 9.66421 6.58244 10.4505 6.1253L11.4288 8.57101L10.1145 10.2167ZM13.5499 6.1253C14.3362 6.58244 14.8574 7.37901 14.8574 8.2853C14.8574 9.05444 14.4825 9.74472 13.8859 10.2167L12.5716 8.57101L13.5499 6.1253ZM13.4356 6.0613C13.0128 5.83958 12.5236 5.71387 12.0002 5.71387C11.4768 5.71387 10.9865 5.83958 10.5648 6.0613L12.0002 7.85558L13.4356 6.0613Z"
          fill="#FFF100"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9998 13.7144C14.8398 13.7144 17.1426 11.4116 17.1426 8.57157C17.1426 5.73157 14.8398 3.42871 11.9998 3.42871C9.15979 3.42871 6.85693 5.73157 6.85693 8.57157C6.85693 11.4116 9.15979 13.7144 11.9998 13.7144ZM11.9998 12.5716C14.2089 12.5716 15.9998 10.7807 15.9998 8.57157C15.9998 6.36243 14.2089 4.57157 11.9998 4.57157C9.79065 4.57157 7.99979 6.36243 7.99979 8.57157C7.99979 10.7807 9.79065 12.5716 11.9998 12.5716Z"
          fill="#FFF100"
        />
        <path
          d="M21.7141 0.571289H2.28557C1.3388 0.571289 0.571289 1.3388 0.571289 2.28557V14.857C0.571289 15.8038 1.3388 16.5713 2.28557 16.5713H21.7141C22.6609 16.5713 23.4284 15.8038 23.4284 14.857V2.28557C23.4284 1.3388 22.6609 0.571289 21.7141 0.571289Z"
          stroke="black"
          strokeOpacity="0.1"
          strokeWidth="1.14286"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_kg">
        <rect width="24" height="17.1429" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const flagUZ = (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_uz)">
      <mask
        id="mask0_uz"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="18"
      >
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_uz)">
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="#D4112A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 12.5713H24V17.1427H0V12.5713Z"
          fill="#20BD42"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H24V4.57143H0V0Z"
          fill="#02A3BD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 5.71401H24V11.4283H0V5.71401ZM5.71429 4.47401C5.536 4.53686 5.34286 4.57115 5.14286 4.57115C4.19657 4.57115 3.42857 3.80315 3.42857 2.85686C3.42857 1.91058 4.19657 1.14258 5.14286 1.14258C5.34286 1.14258 5.536 1.17686 5.71429 1.23972C5.048 1.47515 4.57143 2.11058 4.57143 2.85686C4.57143 3.60315 5.048 4.23972 5.71429 4.47401Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.85742 2.28544H8.00028V3.42829H6.85742V2.28544ZM8.00028 1.14258H9.14314V2.28544H8.00028V1.14258ZM9.14314 2.28544H10.286V3.42829H9.14314V2.28544ZM10.286 1.14258H11.4289V2.28544H10.286V1.14258ZM11.4289 2.28544H12.5717V3.42829H11.4289V2.28544ZM10.286 3.42829H11.4289V4.57115H10.286V3.42829ZM8.00028 3.42829H9.14314V4.57115H8.00028V3.42829Z"
          fill="#78CDDB"
        />
        <path
          d="M21.7141 0.571289H2.28557C1.3388 0.571289 0.571289 1.3388 0.571289 2.28557V14.857C0.571289 15.8038 1.3388 16.5713 2.28557 16.5713H21.7141C22.6609 16.5713 23.4284 15.8038 23.4284 14.857V2.28557C23.4284 1.3388 22.6609 0.571289 21.7141 0.571289Z"
          stroke="black"
          strokeOpacity="0.1"
          strokeWidth="1.14286"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_uz">
        <rect width="24" height="17.1429" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const flagUA = (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <mask id="mask0" maskType="alpha" x="0" y="0" width="24" height="18">
        <path
          d="M21.7143 0H2.2857C1.0234 0 0 1.0234 0 2.2857v12.5714C0 16.1196 1.0234 17.1429 2.2857 17.1429h19.4286C22.9766 17.1429 24 16.1196 24 14.8571V2.2857C24 1.0234 22.9766 0 21.7143 0z"
          fill="#fff"
        />
      </mask>

      <g mask="url(#mask0)">
        <path
          d="M21.7143 0H2.2857C1.0234 0 0 1.0234 0 2.2857v12.5714C0 16.1196 1.0234 17.1429 2.2857 17.1429h19.4286C22.9766 17.1429 24 16.1196 24 14.8571V2.2857C24 1.0234 22.9766 0 21.7143 0z"
          fill="#FFDA00"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0h24v9.1429H0V0z"
          fill="#0266C3"
        />
        <path
          d="M21.714.571H2.286C1.339.571.571 1.339.571 2.286v12.571c0 .947.768 1.714 1.714 1.714h19.428c.947 0 1.714-.767 1.714-1.714V2.286c0-.947-.767-1.715-1.714-1.715z"
          stroke="#000"
          strokeOpacity=".1"
          strokeWidth="1.143"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="24" height="17.143" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);

const flagKZ = (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <mask id="mask0" maskType="alpha" x="0" y="0" width="24" height="18">
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="#00AFCC"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.286 2.851c0-.312.265-.566.571-.566.316 0 .572.247.572.566v2.297c0 .312-.265.566-.572.566a.57.57 0 01-.571-.566V2.851zm1.143 2.28c0-.312.265-.566.572-.566.316 0 .572.247.572.566v2.297c0 .312-.265.566-.572.566a.57.57 0 01-.572-.566V5.131zm0 4.571c0-.312.265-.566.572-.566.316 0 .572.247.572.566v2.297c0 .312-.265.566-.572.566a.57.57 0 01-.572-.566V9.702zM2.286 11.994c0-.312.265-.566.571-.566.316 0 .572.247.572.566v2.297c0 .312-.265.566-.572.566a.57.57 0 01-.571-.566v-2.297zM2.286 7.428c0-.316.265-.572.571-.572.316 0 .572.265.572.572 0 .316-.265.572-.572.572a.57.57 0 01-.571-.572zm1.143-4.571c0-.316.265-.572.572-.572.316 0 .572.265.572.572 0 .316-.265.572-.572.572a.57.57 0 01-.572-.572zM2.286 8.571c0-.316.265-.572.571-.572.316 0 .572.265.572.572 0 .316-.265.571-.572.571a.57.57 0 01-.571-.571zm1.143 5.714c0-.316.265-.572.572-.572.316 0 .572.265.572.572 0 .316-.265.572-.572.572a.57.57 0 01-.572-.572zM2.286 9.714c0-.316.265-.572.571-.572.316 0 .572.265.572.572 0 .316-.265.571-.572.571a.57.57 0 01-.571-.571z"
          fill="#DAC21D"
        />
        <path
          d="M13.143 10.286c1.578 0 2.857-1.279 2.857-2.857 0-1.578-1.279-2.857-2.857-2.857-1.578 0-2.857 1.279-2.857 2.857 0 1.578 1.279 2.857 2.857 2.857z"
          fill="#FFC600"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.143 8l1.143 2.286 2.857 1.143 2.857-1.143L17.143 8v3.429l-4 1.143-4-1.143V8z"
          fill="#FFC600"
        />
        <path
          d="M21.714.571H2.286C1.339.571.571 1.339.571 2.286v12.571c0 .947.768 1.714 1.714 1.714h19.429c.947 0 1.714-.767 1.714-1.714V2.286c0-.947-.767-1.715-1.714-1.715z"
          stroke="#000"
          strokeOpacity=".1"
          strokeWidth="1.143"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="24" height="17.1429" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);

const flagTR = (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4123_5343)">
      <mask
        id="mask0_4123_5343"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="18"
      >
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_4123_5343)">
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="#E70B17"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.0021 9.88776L14.6741 10.5849L14.9278 9.10719L13.8535 8.05919L15.3392 7.84205L16.0021 6.49805L16.6649 7.84319L18.1507 8.06033L17.0764 9.10605L17.3301 10.5838"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.8574 12.5713C13.0666 12.5713 14.8574 10.7804 14.8574 8.57129C14.8574 6.36215 13.0666 4.57129 10.8574 4.57129C8.64828 4.57129 6.85742 6.36215 6.85742 8.57129C6.85742 10.7804 8.64828 12.5713 10.8574 12.5713ZM12.0003 11.4284C13.5774 11.4284 14.8574 10.1484 14.8574 8.57129C14.8574 6.99415 13.5774 5.71415 12.0003 5.71415C10.4231 5.71415 9.14314 6.99415 9.14314 8.57129C9.14314 10.1484 10.4231 11.4284 12.0003 11.4284Z"
          fill="white"
        />
        <path
          d="M21.7141 0.571289H2.28557C1.3388 0.571289 0.571289 1.3388 0.571289 2.28557V14.857C0.571289 15.8038 1.3388 16.5713 2.28557 16.5713H21.7141C22.6609 16.5713 23.4284 15.8038 23.4284 14.857V2.28557C23.4284 1.3388 22.6609 0.571289 21.7141 0.571289Z"
          stroke="black"
          strokeOpacity="0.1"
          strokeWidth="1.14286"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4123_5343">
        <rect width="24" height="17.1429" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const flagEE = (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4123_5518)">
      <mask
        id="mask0_4123_5518"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="18"
      >
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_4123_5518)">
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 11.4287H24V17.143H0V11.4287Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H24V5.71429H0V0Z"
          fill="#448FDC"
        />
        <path
          d="M21.7141 0.571289H2.28557C1.3388 0.571289 0.571289 1.3388 0.571289 2.28557V14.857C0.571289 15.8038 1.3388 16.5713 2.28557 16.5713H21.7141C22.6609 16.5713 23.4284 15.8038 23.4284 14.857V2.28557C23.4284 1.3388 22.6609 0.571289 21.7141 0.571289Z"
          stroke="black"
          strokeOpacity="0.1"
          strokeWidth="1.14286"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4123_5518">
        <rect width="24" height="17.1429" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const flagIT = (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <mask
        id="mask0"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="18"
      >
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="#fff"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H8V17.1429H0V0Z"
          fill="#009342"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 0H24V17.1429H16V0Z"
          fill="#D02832"
        />
        <path
          d="M21.7141 0.571289H2.28557C1.3388 0.571289 0.571289 1.3388 0.571289 2.28557V14.857C0.571289 15.8038 1.3388 16.5713 2.28557 16.5713H21.7141C22.6609 16.5713 23.4284 15.8038 23.4284 14.857V2.28557C23.4284 1.3388 22.6609 0.571289 21.7141 0.571289Z"
          stroke="black"
          strokeOpacity="0.1"
          strokeWidth="1.14286"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="24" height="17.1429" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);

const flagPL = (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <mask
        id="mask0"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="18"
      >
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="#DF0A37"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H24V9.14286H0V0Z"
          fill="#fff"
        />
        <path
          d="M21.7141 0.571289H2.28557C1.3388 0.571289 0.571289 1.3388 0.571289 2.28557V14.857C0.571289 15.8038 1.3388 16.5713 2.28557 16.5713H21.7141C22.6609 16.5713 23.4284 15.8038 23.4284 14.857V2.28557C23.4284 1.3388 22.6609 0.571289 21.7141 0.571289Z"
          stroke="black"
          strokeOpacity="0.1"
          strokeWidth="1.14286"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="24" height="17.1429" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);

const flagES = (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <mask
        id="mask0"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="18"
      >
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          d="M21.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V14.8571C0 16.1195 1.02335 17.1429 2.28571 17.1429H21.7143C22.9767 17.1429 24 16.1195 24 14.8571V2.28571C24 1.02335 22.9767 0 21.7143 0Z"
          fill="#CD0B20"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 4.57129H24V12.5713H0V4.57129Z"
          fill="#FFCB00"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.2856 7.10978V9.98978C10.2856 10.7898 9.51757 11.4298 8.57129 11.4298H6.28557C5.34157 11.4275 4.57129 10.7841 4.57129 9.9875V7.1075C4.57129 6.45378 5.08329 5.9075 5.78729 5.73035C5.99986 5.13607 6.65357 5.66864 7.42843 5.66864C8.20786 5.66864 8.857 5.1395 9.06957 5.7315C9.77129 5.91321 10.2856 6.46064 10.2856 7.10978Z"
          fill="#C8B47C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.2859 8H11.4287V11.4286H10.2859V8ZM3.42871 8H4.57157V11.4286H3.42871V8Z"
          fill="#B5B5B5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.2859 10.2852H11.4287V11.428H10.2859V10.2852ZM3.42871 10.2852H4.57157V11.428H3.42871V10.2852Z"
          fill="#165C96"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.2859 6.85742H11.4287V8.00028H10.2859V6.85742ZM3.42871 6.85742H4.57157V8.00028H3.42871V6.85742Z"
          fill="#A0790A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.71387 6.85742H6.85672V8.57171H5.71387V6.85742ZM7.99958 9.14314H9.14244V10.8574H7.99958V9.14314Z"
          fill="#D20636"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 6.85742H9.14286V8.57171H8V6.85742Z"
          fill="#A18793"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.71387 9.14258H6.85672V10.8569H5.71387V9.14258Z"
          fill="#FFE100"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.85672 6.85672L5.71387 5.71387H9.14244L7.99958 6.85672H6.85672Z"
          fill="#B6161A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.85742 4.57129H8.00028V5.71415H6.85742V4.57129Z"
          fill="#AC9300"
        />
        <path
          d="M21.7141 0.571289H2.28557C1.3388 0.571289 0.571289 1.3388 0.571289 2.28557V14.857C0.571289 15.8038 1.3388 16.5713 2.28557 16.5713H21.7141C22.6609 16.5713 23.4284 15.8038 23.4284 14.857V2.28557C23.4284 1.3388 22.6609 0.571289 21.7141 0.571289Z"
          stroke="black"
          strokeOpacity="0.1"
          strokeWidth="1.14286"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="24" height="17.1429" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);

const flagFR = (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4123_5358)">
      <mask
        id="mask0_4123_5358"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="18"
        style={{ maskType: "alpha" }}
      >
        <path
          d="M21.7143 0H2.2857C1.0233 0 0 1.0233 0 2.2857v12.5714C0 16.1195 1.0233 17.1429 2.2857 17.1429h19.4286C22.9767 17.1429 24 16.1195 24 14.8571V2.2857C24 1.0233 22.9767 0 21.7143 0Z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#mask0_4123_5358)">
        <path
          d="M21.7143 0H2.2857C1.0233 0 0 1.0233 0 2.2857v12.5714C0 16.1195 1.0233 17.1429 2.2857 17.1429h19.4286C22.9767 17.1429 24 16.1195 24 14.8571V2.2857C24 1.0233 22.9767 0 21.7143 0Z"
          fill="#fff"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0h8v17.1429H0V0Z"
          fill="#001C98"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 0h8v17.1429h-8V0Z"
          fill="#F02532"
        />
        <path
          d="M21.7141.5713H2.2856c-.9468 0-1.7143.7675-1.7143 1.7143v12.5714c0 .9468.7675 1.7143 1.7143 1.7143h19.4285c.9468 0 1.7143-.7675 1.7143-1.7143V2.2856c0-.9468-.7675-1.7143-1.7143-1.7143Z"
          stroke="#000"
          strokeOpacity="0.1"
          strokeWidth="1.14286"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4123_5358">
        <rect width="24" height="17.1429" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);

const flagGE = (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4123_5361)">
      <mask
        id="mask0_4123_5361"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="18"
        style={{ maskType: "alpha" }}
      >
        <path
          d="M21.7143 0H2.2857C1.0233 0 0 1.0233 0 2.2857v12.5714C0 16.1195 1.0233 17.1429 2.2857 17.1429h19.4286C22.9767 17.1429 24 16.1195 24 14.8571V2.2857C24 1.0233 22.9767 0 21.7143 0Z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#mask0_4123_5361)">
        <path
          d="M21.7143 0H2.2857C1.0233 0 0 1.0233 0 2.2857v12.5714C0 16.1195 1.0233 17.1429 2.2857 17.1429h19.4286C22.9767 17.1429 24 16.1195 24 14.8571V2.2857C24 1.0233 22.9767 0 21.7143 0Z"
          fill="#fff"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.2857 10.2857H0V6.8571h10.2857V0h3.4286v6.8571H24v3.4286H13.7143v6.8572h-3.4286v-6.8572Z"
          fill="#FF0000"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.1427 12.5709h-1.1428v1.1428h1.1428v1.1429h1.1429v-1.1429h1.1428v-1.1428h-1.1428v-1.1429h-1.1429v1.1429Zm0-9.1429h-1.1428v1.1429h1.1428v1.1429h1.1429V4.5709h1.1428V3.428h-1.1428V2.2851h-1.1429V3.428Zm-11.4286 0H4.5713v1.1429h1.1428v1.1429H6.857V4.5709h1.1429V3.428H6.857V2.2851H5.7141V3.428Zm0 9.1429H4.5713v1.1428h1.1428v1.1429H6.857v-1.1429h1.1429v-1.1428H6.857V11.428H5.7141v1.1429Z"
          fill="#FF0000"
        />
        <path
          d="M21.7141.5713H2.2856c-.9468 0-1.7143.7675-1.7143 1.7143v12.5714c0 .9468.7675 1.7143 1.7143 1.7143h19.4285c.9468 0 1.7143-.7675 1.7143-1.7143V2.2856c0-.9468-.7675-1.7143-1.7143-1.7143Z"
          stroke="#000"
          strokeOpacity="0.1"
          strokeWidth="1.14286"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4123_5361">
        <rect width="24" height="17.1429" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
